export default "__VITE_ASSET__bc9d9653__"